/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Weclapp_Time_Filter_Last_DaysInputs */



/**
* | output |
* | --- |
* | "Last N days" |
*
* @param {Spaces_Weclapp_Time_Filter_Last_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_weclapp_time_filter_last_days = /** @type {((inputs?: Spaces_Weclapp_Time_Filter_Last_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Weclapp_Time_Filter_Last_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte N Tage")
	return /** @type {LocalizedString} */ ("Last N days")
});